"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
exports.BasicColors = ['A', 'B', 'C', 'D', 'E'];
exports.AllNums = [1, 2, 3, 4, 5];
function getNumDistribution(color) {
    return color === 'K' ? [1, 2, 2, 3, 3, 4, 4, 5, 5, 5] : [1, 1, 1, 2, 2, 3, 3, 4, 4, 5];
}
exports.getNumDistribution = getNumDistribution;
function getAllColors({ useRainbow, useBlack }) {
    return ['A', 'B', 'C', 'D', 'E', ...(useRainbow ? ['X'] : []), ...(useBlack ? ['K'] : [])];
}
exports.getAllColors = getAllColors;
function parseValueString(str) {
    if (/^([ABCDEXK])([1-5])$/.test(str)) {
        return { color: RegExp.$1, num: +RegExp.$2 };
    }
    else {
        throw new errors_1.SyntaxError('INVALID_VALUE_STRING', str);
    }
}
class BaseCard {
    constructor(c) {
        this.hints = [];
        if (typeof c === 'string') {
            const { color, num } = parseValueString(c);
            this.color = color;
            this.num = num;
        }
        else {
            this.color = c.color;
            this.num = c.num;
            this.hints = c.hints || [];
        }
    }
    get value() {
        return this.color + this.num;
    }
}
class Card extends BaseCard {
    static fromValueString(str) {
        return new Card(parseValueString(str));
    }
    static getFullDeck(deckParams) {
        return getAllColors(deckParams).flatMap(color => getNumDistribution(color).map((num) => new Card({ color, num })));
    }
    toJSON() {
        return this.color + this.num;
    }
    serializeWithHints() {
        return {
            color: this.color,
            num: this.num,
            hints: this.hints,
        };
    }
    matchesHints(hints) {
        // console.warn(
        //   'MATCHESHINTS',
        //   hints,
        //   this.value,
        //   hints.every(h => (h.result ? this.looksLike(h.is) : !this.looksLike(h.is))),
        // )
        return hints.every(h => (h.result ? this.looksLike(h.is) : !this.looksLike(h.is)));
    }
    equals(subject) {
        return this.color === subject.color && this.num === subject.num;
    }
    looksLike(subject) {
        if (typeof subject === 'number') {
            return this.num === subject;
        }
        else {
            return this.color === subject || this.color === 'X';
        }
    }
    addHint(hint) {
        this.hints.push(Object.assign(Object.assign({}, hint), { result: this.color === hint.is || (this.color === 'X' && typeof hint.is === 'string') || this.num === hint.is }));
    }
}
exports.Card = Card;
class MaskedCard {
    constructor(c) {
        this.hints = [];
        this.color = c.color;
        this.num = c.num;
        this.actionability = c.actionability;
        if (c.possibleCards)
            this.possibleCards = c.possibleCards.map(pc => new PossibleCard(pc));
        if (c.was)
            this.was = new Card(c.was);
        this.hints = c.hints || [];
    }
    get value() {
        return this.color && this.num ? this.color + this.num : undefined;
    }
    toJSON() {
        return {
            color: this.color,
            num: this.num,
            actionability: this.actionability,
            possibleCards: this.possibleCards && this.possibleCards.length ? this.possibleCards.map(pc => pc.toJSON()) : undefined,
            hints: this.hints,
            was: this.was,
        };
    }
}
exports.MaskedCard = MaskedCard;
class PossibleCard extends BaseCard {
    constructor(pc) {
        super(pc.value);
        this.prob = pc.prob;
        this.count = pc.count;
        this.actionability = pc.actionability;
    }
    toJSON() {
        return { value: this.value, prob: this.prob, count: this.count, actionability: this.actionability };
    }
}
exports.PossibleCard = PossibleCard;
//# sourceMappingURL=card.js.map